<div class="wrapper">
  <app-property-share-buyers-list
    [propertyId]="propertyId"
    type="EMAIL"
  ></app-property-share-buyers-list>

  <h4 class="title">Manually enter email addresses:</h4>
  <div *ngIf="emails.length > 0" class="emails">
    <div *ngFor="let email of emails; let i = index" class="email">
      <div>{{ email }}</div>
      <img
        src="/assets/icons/close.svg"
        alt="Remove email"
        width="8"
        class="remove"
        (click)="removeEmail(i)"
      />
    </div>
  </div>

  <div class="form">
    <div class="flex-1">
      <app-shared-input
        for="share-email"
        [value]="emailValue"
        [errors]="emailInvalid ? { email: 'Invalid email address' } : undefined"
        [touched]="emailTouched"
      >
        <input
          name="share-email"
          id="share-email"
          type="email"
          [(ngModel)]="emailValue"
          placeholder="Click + to add more emails"
          (keydown.enter)="addEmail()"
          (blur)="onEmailBlur()"
        />
      </app-shared-input>
    </div>
    <app-shared-button size="large" class="ml-2" (click)="addEmail()">
      +
    </app-shared-button>
  </div>

  <div class="buttons">
    <app-shared-button
      (click)="handleSend()"
      [disabled]="emails.length <= 0"
      [loading]="sending"
    >
      Send
    </app-shared-button>
    <app-shared-button
      (click)="handleClose.emit()"
      class="ml-2"
      theme="outline"
    >
      Cancel
    </app-shared-button>
  </div>

  <div *ngIf="!sendResp && !!emailTouched" class="input-error-message">
    <div class="font-medium">Add at least one email address to send.</div>
  </div>

  <div
    *ngIf="sendResp"
    class="response-message"
    [ngClass]="{ error: sendResp.type === 'error' }"
  >
    {{ sendResp.message }}
  </div>
</div>
